// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__3u71Y","alignBottom":"styles_alignBottom__38kWx","formClass":"styles_formClass__2NfKM"};